import type { FC } from "react";
import { AdminBondRequestPelPmlCard } from "../overview/AdminBondRequestPelPmlCard";
import type { BondRequestTabProps } from "../types";

export const AdminBondRequestPelPmlTab: FC<BondRequestTabProps> = ({ request }) => (
	<div className="flex flex-col space-y-[40px]" data-testid="admin-bond-request-pel-pml-tab">
		<AdminBondRequestPelPmlCard request={request} />
	</div>
);
